import global$1 from './global.js';
import anObject$1 from './an-object.js';
import ordinaryToPrimitive$1 from './ordinary-to-primitive.js';

var global = global$1;
var anObject = anObject$1;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var TypeError = global.TypeError; // `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive

var dateToPrimitive = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';else if (hint !== 'number') throw TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};

export { dateToPrimitive as default };
